import styled from 'styled-components';

const Title = styled.h1`
  font-size: 6rem;
  font-family: Poppins;
  font-weight: 600;
  line-height: 5rem;
`;

export default Title;
